var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMmFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MM_Flag",
    transform: "translate(-18.382 -18.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M40.646,18.381H30.119A11.75,11.75,0,0,0,18.382,30.117V40.645A11.75,11.75,0,0,0,30.119,52.381H40.646A11.749,11.749,0,0,0,52.382,40.645V30.117A11.749,11.749,0,0,0,40.646,18.381Z",
    transform: "translate(0 -0.001)",
    fill: "#33ac31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M52.5,30.058H18.52A11.96,11.96,0,0,1,30.247,18.38H40.774A11.959,11.959,0,0,1,52.5,30.058Z",
    transform: "translate(-0.128)",
    fill: "#f7c500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M52.5,336.4a11.959,11.959,0,0,1-11.726,11.678H30.246A11.96,11.96,0,0,1,18.519,336.4Z",
    transform: "translate(-0.127 -295.697)",
    fill: "#e32738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M18.424,40.626V30.133A11.96,11.96,0,0,1,30.611,18.422h4.23c-3.314.64-12.262,3.112-13.617,11.024l-.063,12.9s.326,5.259,2.749,8.057a11.6,11.6,0,0,1-5.485-9.781Z",
    transform: "translate(-0.039 -0.039)",
    fill: "#fff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M153.466,30.16V40.678a11.676,11.676,0,0,1-11.6,11.738h-10.4a11.515,11.515,0,0,1-3.884-.677l10.481-.907c10.828-1.511,11.246-8.91,11.246-8.91l-.048-12.85s-.227-7.555-9.226-10.65h1.829A11.676,11.676,0,0,1,153.466,30.16Z",
    transform: "translate(-101.087 -0.039)",
    fill: "#160204",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M119.941,130.654a.667.667,0,0,0,.253-.755l-2.133-6.8,5.811-4.43a.679.679,0,0,0-.414-1.22h-7.077L114,110.908a.683.683,0,0,0-1.287.015l-2.211,6.523h-7.156a.68.68,0,0,0-.417,1.218L108.554,123l-2.22,6.894a.681.681,0,0,0,1.039.766l6.019-4.17,5.752,4.161A.7.7,0,0,0,119.941,130.654Z",
    transform: "translate(-78.018 -85.241)",
    fill: "#efefef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmFlag);
export default __webpack_public_path__ + "static/media/MM_Flag.6f70da18bd4bb08496c2c5df52234387.svg";
export { ForwardRef as ReactComponent };